<template>
    <div>
        <div class="w-full z-20 p-2 sticky -top-7 sm:top-4">
            <div
                class="w-full select-none flex flex-wrap sm:flex-row items-center justify-center sm:justify-between lg:px-2 w-full text-3xl mb-2 text-gray-400 font-medium">
                <div class="flex items-center gap-x-2">
                    <span class="whitespace-nowrap">{{ userFilterOnCurrentUser ? "Your" : "" }} To-dos</span>
                    <button v-if="overdueTodosCount !== 0"
                            class="bg-red-100 text-md font-normal text-red-600 px-1 rounded hover:bg-indigo-100 hover:text-indigo-600 transition duration-300"
                            title="Your Overdue Todos"
                            @click="filterOverdueTodos()">{{ overdueTodosCount }}
                    </button>
                </div>

                <div class="flex items-center space-x-4 ml-2">
                    <button v-if="!filters.completed && !filters.archived"
                            class="flex items-center gap-2 hover:text-yellow-600 cursor-pointer transition duration-300"
                            @click="toggleArchiveAllDialog()">
                        <icon-archive-box class="w-6 h-6"></icon-archive-box>

                        <span class="text-sm">archive all</span>
                    </button>

                    <button v-if="!filters.completed && !filters.archived"
                            class="flex items-center gap-2 hover:text-indigo-600 cursor-pointer transition duration-300"
                            @click="toggleCompleteAllDialog()">
                        <icon-thumbs-up class="w-6 h-6"></icon-thumbs-up>

                        <span class="text-sm">complete all</span>
                    </button>
                </div>
            </div>

            <div class="col-span-6 md:col-span-4 md:col-start-2 mb-4">
                <expandable-filters-container
                    :advanced-filters-expanded="showAdvancedSearch"
                    @toggle-expand="toggleAdvancedSearch()"
                    @apply-filters="fetchTodos(); toggleAdvancedSearch()"
                    @reset-filters="resetFilters()">

                    <div slot="top-panel-left" class="flex flex-wrap items-center gap-4 todo-list-filters">
                        <simple-text-search-input
                            class="mt-4 sm:mt-0"
                            text-search-placeholder="10 Rabbit Road / TR435"
                            text-search-label="Search Asset or Ticket"
                            input-styles="min-width:220px"
                            v-model="filters.filter_text"
                            @input="fetchTodos(); closeAdvancedSearch()"
                        ></simple-text-search-input>

                        <el-select placeholder="All Types"
                                   class="h-10"
                                   v-model="filters.types"
                                   @input="fetchTodos(); closeAdvancedSearch()"
                                   multiple clearable collapse-tags>
                            <el-option v-for="type in todoTypes" :key="type" :label="type | titlecase" :value="type"></el-option>
                        </el-select>

                        <span v-if="activeFiltersCount > 0"
                              class="h-6 inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-500 text-white">
                            <span>{{ activeFiltersCount + " Active Filter" | pluralizeOnlyS(activeFiltersCount) }} </span>
                            <button @click.prevent="resetFilters(); fetchTodos();" title="Clear All Filters"
                                    class="flex ml-2 cursor-pointer">
                                <icon-x-circle class="w-3 h-3 text-white hover:text-indigo-700"></icon-x-circle>
                            </button>
                        </span>
                    </div>

                    <div slot="expanded-filters-container" class="mx-auto p-8">
                        <div class="grid grid-cols-1 sm:grid-cols-3 gap-y-4 gap-x-8">
                            <div class="flex flex-col">
                                <label class="font-normal text-gray-600">Assigned To</label>
                                <el-select placeholder="All Users"
                                           v-model="filters.user_ids" multiple clearable>
                                    <el-option
                                        class="font-medium"
                                        key="noUsersAssignedKey"
                                        label="No Users"
                                        value="No Users">
                                    </el-option>
                                    <el-option
                                        v-for="user in state.currentTeam.active_users"
                                        :key="user.id + user.name"
                                        :label="user.name | titlecase"
                                        :value="user.id">
                                    </el-option>
                                </el-select>
                            </div>

                            <div class="flex flex-col">
                                <label class="font-normal text-gray-600">Portfolios</label>
                                <el-select placeholder="All Portfolios"
                                           v-model="filters.portfolio_ids" multiple clearable>
                                    <el-option
                                        v-for="portfolio in portfolioFilterOptions"
                                        :key="portfolio.id + portfolio.name"
                                        :label="portfolio.name | titlecase"
                                        :value="portfolio.id">
                                    </el-option>
                                </el-select>
                            </div>

                            <div class="flex flex-col">
                                <label class="font-normal text-gray-600">Reminder Date</label>
                                <el-date-picker
                                    v-model="filters.date_range"
                                    class="w-full sm:w-56"
                                    :picker-options="datePickerOptions"
                                    value-format="yyyy-MM-dd"
                                    format="dd-MM-yy"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="From"
                                    end-placeholder="To">
                                </el-date-picker>
                            </div>

                            <!-- Completed Todos-->
                            <div class="items-center flex">
                                <checkbox v-model="filters.completed"
                                          label="Only Completed"
                                          label-styling="font-normal text-gray-600">
                                </checkbox>

                            </div>
                            <div class="items-center flex">
                                <!-- Archived Todos-->
                                <checkbox v-model="filters.archived"
                                          label="Only Archived"
                                          label-styling="font-normal text-gray-600">
                                </checkbox>
                            </div>
                        </div>
                    </div>

                    <div slot="expanded-filters-container-footer">
                        <span v-if="selectedFiltersCount > 0"
                              class="h-6 ml-4 inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-500 text-white">
                            <span>{{ selectedFiltersCount + " Selected Filter" | pluralizeOnlyS(selectedFiltersCount) }} </span>
                            <button @click.prevent="resetFilters();" title="Clear All Filters"
                                    class="flex ml-2 cursor-pointer">
                                <icon-x-circle class="w-3 h-3 text-white hover:text-indigo-700"></icon-x-circle>
                            </button>
                        </span>
                    </div>
                </expandable-filters-container>
            </div>
        </div>

        <ul class="w-full bg-gray-100 px-2" v-if="!loadingTodos">
            <todo-list-item v-for="(todo, index) in mutableTodos" :todo="todo" :key="index" :index="index"
                            @toggle-create-edit-modal="selectOrUnselectTodo(todo)"
                            @show-inspection-create-form="showInspectionCreateForm(todo)"
                            @todo-updated="todoUpdated"
                            @todo-changed="todoChanged">
            </todo-list-item>

            <simple-pagination
                v-if="mutableTodos && mutableTodos.length > 0"
                :meta="paginationData.meta"
                padding="2"
                class="mt-2"
                per-page="10"
                side-navigation-count="5"
                @page-changed="fetchTodos">
            </simple-pagination>
        </ul>

        <div v-if="loadingTodos" class="flex justify-center items-center mt-10 mb-96 font-medium text-lg text-gray-500">
            <icon-refresh class="h-6 w-6 animate-spin text-indigo-600"/> &nbsp;Loading To-dos...
        </div>

        <!-- Empty View displayed if there are no ticket follow up reminders -->
        <div v-if="!loadingTodos && mutableTodos.length <= 0" style="min-height: 300px;"
             class="flex flex-col items-center justify-center space-y-4 h-full select-none">
            <span class="text-lg font-medium leading-none">{{ activeFiltersCount > 0 ? "No to-dos with those filters" : "No To-dos Left For Today" }}</span>
            <span class="text-gray-600 text-base">{{ activeFiltersCount > 0 ? "Try different filters" : "Well Done!" }}</span>
            <img v-if="activeFiltersCount === 0" style="max-width: 120px" :src="`/images/empty-todo-list/${randomEmptyViewImage}.png`" alt="image"/>
        </div>

        <simple-modal :show="showCreateTodoModal" @close="selectOrUnselectTodo()"
                      :title="selectedTodo ? 'Update To-do' : 'Create To-do'">
            <todo-create-edit-form :todo="selectedTodo" @todo-updated="todoUpdated" @todo-created="fetchTodos" @close="selectOrUnselectTodo()"></todo-create-edit-form>
        </simple-modal>

        <inspection-create-form
            ref="inspectionCreateFormOnTodoList"
            :todo-id="selectedTodo ? selectedTodo.id : null"
            @close="inspectionScheduledFromTodo"
            :asset="selectedTodo && selectedTodo.asset ? selectedTodo.asset : null"
            :inspection-types="state.currentTeam.inspection_settings.inspection_types">
        </inspection-create-form>

        <confirmation-dialog
            :show="showCompleteAllDialog"
            title="Complete all to-dos"
            subtitle="Are you sure you want to complete all visible to-dos as per the current filters? To-dos with repeat options WILL be repeated."
            :show-icon="false"
            proceed-button-text="Yes, Complete All"
            cancel-button-text="No, Return"
            proceed-button-colour="indigo-600"
            proceed-button-hover-colour="indigo-400"
            @cancelled="toggleCompleteAllDialog()"
            @proceed="completeAll()">
        </confirmation-dialog>

        <confirmation-dialog
            :show="showArchiveAllDialog"
            title="Archive all to-dos"
            subtitle="Are you sure you want to archive all visible to-dos as per the current filters? To-dos with repeat options WON'T be repeated."
            :show-icon="false"
            proceed-button-text="Yes, Archive All"
            cancel-button-text="No, Return"
            proceed-button-colour="indigo-600"
            proceed-button-hover-colour="indigo-400"
            @cancelled="toggleArchiveAllDialog()"
            @proceed="archiveAll()">
        </confirmation-dialog>
    </div>
</template>

<script>

export default {
    name: "TodoList",

    data () {
        return {
            loadingTodos: true,
            mutableTodos: [],
            paginationData: {},
            overdueTodosCount: 0,
            selectedTodo: null,
            filters: {},
            activeFiltersCount: 0,
            showAdvancedSearch: false,
            showCreateTodoModal: false,
            showCompleteAllDialog: false,
            showArchiveAllDialog: false,
            todoTypes: ["review ticket", "schedule inspection"],
            datePickerOptions: {
                shortcuts: [{
                    text: "Last 90 Days",
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit("pick", [start, end]);
                    }
                }, {
                    text: "Last 30 Days",
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit("pick", [start, end]);
                    }
                }, {
                    text: "Last 7 Days",
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit("pick", [start, end]);
                    }
                }, {
                    text: "Today",
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        picker.$emit("pick", [start, end]);
                    }
                }, {
                    text: "Tomorrow",
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() + 3600 * 1000 * 24);
                        end.setTime(end.getTime() + 3600 * 1000 * 24);
                        picker.$emit("pick", [start, end]);
                    }
                }, {
                    text: "Next 7 Days",
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
                        picker.$emit("pick", [start, end]);
                    }
                }, {
                    text: "Next 30 Days",
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
                        picker.$emit("pick", [start, end]);
                    }
                }, {
                    text: "Next 90 Days",
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        end.setTime(end.getTime() + 3600 * 1000 * 24 * 90);
                        picker.$emit("pick", [start, end]);
                    }
                }]
            },
        };
    },

    computed: {
        randomEmptyViewImage () {
            //Randomly select image to display for empty view
            return _.sample(["astronaut",
                "baby-toy", "barbeque", "barn", "cabin", "cake", "camping", "celebrating", "cheetah",
                "chick", "circus", "city", "crown", "donut", "elephant", "farmer", "ferris-wheel",
                "fuji", "green-point-lighthouse", "gyeongbokgung-palace", "hamburger", "hills", "ice-hockey",
                "icecream", "inspection", "inspection-home", "island", "kaminarimon-gate", "king-protea",
                "koi-fish", "meat", "ninja", "outer-space", "panda", "parrot", "pirate", "planet", "planets", "pyramid",
                "pyramid-front", "rabbit", "roasted-chicken", "roller-skates", "saturn", "sheep", "ship", "sloth",
                "south-africa", "springbok", "squid", "star", "sun", "swords", "table-mountain", "tiki-mask", "toast",
                "torii-gate", "trees", "turtle", "viking-ship", "zulu", "zulu-2"
            ]);
        },

        userFilterOnCurrentUser () {
            if (this.filters && this.filters.user_ids) {
                return this.filters.user_ids.length === 1 && this.filters.user_ids.includes(this.state.user.id);
            }

            return false;
        },

        today () {
            return this.$dayjs().format("YYYY-MM-DD");
        },

        dateFilterOnToday () {
            if (this.filters && this.filters.date_range) {
                return this.filters.date_range.every(value => value === this.today);
            }

            return false;
        },

        selectedFiltersCount () {
            let count = 0;
            if (Object.keys(this.filters).length > 0) {
                if (this.filters.archived) {count++;}
                if (this.filters.completed) {count++;}
                if (!this.dateFilterOnToday && (!this.filters.date_range || (this.filters.date_range && this.filters.date_range.length !== 0))) {count++;}
                if (this.filters.types.length !== 0) {count++;}
                if (this.filters.portfolio_ids.length !== 0) {count++;}
                if (this.filters.user_ids && !this.userFilterOnCurrentUser) {count++;}
                if (this.filters.filter_text !== "") {count++;}
            }
            return count;
        },

        portfolioFilterOptions () {
            return _.sortBy(this.state.user.portfolios, "name");
        },
    },

    mounted () {
        this.resetFilters();

        let url = new URL(window.location.href);
        if (url.searchParams.get("todo_type")) {
            this.filters.types[0] = url.searchParams.get("todo_type");
        }

        if (url.search.includes("date_range")) {
            this.filters.date_range = [];
            this.filters.date_range.push(url.searchParams.get("date_range[0]"));
            this.filters.date_range.push(url.searchParams.get("date_range[1]"));
        }

        this.fetchTodos();
    },

    methods: {
        resetFilters () {
            this.filters = {
                archived: false,
                completed: false,
                date_range: [this.today, this.today],
                filter_text: "",
                portfolio_ids: [],
                types: [],
                user_ids: [this.state.user.id],
            };
        },

        fetchTodos: _.debounce(function (paginationSettings = null) {
            this.loadingTodos = true;

            axios.get("todos", {
                params: Object.assign(this.filters, {
                    page: paginationSettings && paginationSettings.pageNumber ? paginationSettings.pageNumber : 1,
                    per_page: paginationSettings && paginationSettings.perPage ? paginationSettings.perPage : 10,
                })
            }).then(response => {
                this.mutableTodos = response.data.data;
                this.paginationData = response.data;
                this.overdueTodosCount = response.data.overdue_todos_count;
                this.activeFiltersCount = this.selectedFiltersCount;
                this.loadingTodos = false;
            })
            .catch(error => {
                this.loadingTodos = false;
                toastr.error(error.message);
            });
        }, 300),

        toggleCompleteAllDialog () {
            this.showCompleteAllDialog = !this.showCompleteAllDialog;
        },

        completeAll () {
            if (this.mutableTodos && this.mutableTodos.length === 0) {
                toastr.error("There are no to-dos with the current filters to complete");
                return;
            }

            let todoIds = this.mutableTodos.map(todo => {return todo.id;});

            App.post(`/todos/complete-all`, new AppForm({
                todo_ids: todoIds,
            }))
            .then(response => {
                this.resetFilters();
                this.fetchTodos();
                this.toggleCompleteAllDialog();
                toastr.success(response);
            })
            .catch(error => {
                toastr.error("Could not complete all to-dos. Error: " + error.message);
            });
        },

        toggleArchiveAllDialog () {
            this.showArchiveAllDialog = !this.showArchiveAllDialog;
        },

        archiveAll () {
            if (this.mutableTodos && this.mutableTodos.length === 0) {
                toastr.error("There are no to-dos with the current filters to archive");
                return;
            }

            let todoIds = this.mutableTodos.map(todo => {return todo.id;});

            App.post(`/todos/archive-all`, new AppForm({
                todo_ids: todoIds,
            }))
            .then(response => {
                this.resetFilters();
                this.fetchTodos();
                this.toggleArchiveAllDialog();
                toastr.success(response);
            })
            .catch(error => {
                toastr.error("Could not archive all to-dos. Error: " + error.message);
            });
        },

        toggleAdvancedSearch () {
            this.showAdvancedSearch = !this.showAdvancedSearch;
        },

        closeAdvancedSearch () {
            this.showAdvancedSearch = false;
        },

        selectOrUnselectTodo (todo = null, toggleCreateEditModal = true) {
            // Reset or take new one
            this.selectedTodo = todo;
            if (toggleCreateEditModal) {
                this.toggleCreateTodoModal();
            }
        },

        todoUpdated (todo) {
            let index = this.mutableTodos.findIndex(t => t.id === todo.id);
            if (index !== -1) {
                this.mutableTodos.splice(index, 1, todo);
            }
        },

        todoChanged () {
            this.fetchTodos();
        },

        todoCreated (todo) {
            this.mutableTodos.prepend(todo);
        },

        toggleCreateTodoModal () {
            this.showCreateTodoModal = !this.showCreateTodoModal;
        },

        showInspectionCreateForm (todo) {
            this.selectOrUnselectTodo(todo, false);
            this.$refs.inspectionCreateFormOnTodoList.showInspectionCreateForm();
        },

        inspectionScheduledFromTodo (inspection) {
            if (inspection) {
                toastr.success("Inspection Scheduled. To-do Automatically Completed");
                this.fetchTodos();
            }
            this.selectOrUnselectTodo(null, false);
        },

        filterOverdueTodos () {
            this.filters.date_range = [this.$dayjs().subtract(10, "years").format("YYYY-MM-DD"), this.$dayjs().subtract(1, "days").format("YYYY-MM-DD")];
            this.filters.user_ids = [this.state.user.id];
            this.filters.completed = false;
            this.filters.archived = false;
            this.filters.types = [];
            this.filters.portfolio_ids = [];
            this.filters.filter_text = null;
            this.fetchTodos();
        },
    },
};
</script>

<style>
.todo-list-filters .el-input__inner {
    height: 2.58rem !important
}

</style>
